/**
 * Credits granted to a new self-serve account on signup, so it can run a real
 * simulation before ever reaching Stripe Checkout. Lives here (rather than in
 * @lensora/billing) because the dashboard's signup copy needs the same number
 * and must not pull the Stripe Node SDK into the browser bundle — the same
 * reason PLATFORM_QUERY_CREDIT_COST is shared. The billing policy that
 * consumes it is in packages/billing/src/trial.ts.
 *
 * Sized against apps/api/src/lib/ai/credits.ts: onboarding prompt suggestions
 * (1) + one default Prompts run of 1 prompt x 5 non-growth platforms (5) + a
 * website audit crawl (2), with room for ~3 further full-platform runs.
 */
export const TRIAL_CREDIT_GRANT = 25;
//# sourceMappingURL=credits.js.map